import { axiosClient } from "services/axios";

import {
  ChequePrintTemplate,
  CreateChequePrintTemplateBody,
  UpdateChequePrintTemplateBody,
} from "../types";

/** Относительно baseURL axios (`api.admin/`). Бэкенд: GET/POST/PUT/DELETE …/print-templates */
const BASE = "print-templates";

export function getChequePrintTemplates(params?: {
  page?: number;
  pageSize?: number;
  includeDeleted?: boolean | 1;
}) {
  return axiosClient
    .get(`${BASE}/`, { params })
    .then((res) => res.data as ChequePrintTemplate[]);
}

export function getChequePrintTemplate(
  printtemplateid: number,
  params?: { includeDeleted?: boolean | 1 }
) {
  return axiosClient
    .get(`${BASE}/${printtemplateid}`, { params })
    .then((res) => res.data as ChequePrintTemplate);
}

export function createChequePrintTemplate(data: CreateChequePrintTemplateBody) {
  return axiosClient
    .post(`${BASE}/`, data)
    .then((res) => res.data as ChequePrintTemplate);
}

export function updateChequePrintTemplate(data: UpdateChequePrintTemplateBody) {
  return axiosClient
    .put(`${BASE}/`, data)
    .then((res) => res.data as ChequePrintTemplate);
}

export function deleteChequePrintTemplate(printtemplateid: number) {
  return axiosClient.delete(`${BASE}/${printtemplateid}`);
}
